import { render, staticRenderFns } from "./PartografTimeHeader.vue?vue&type=template&id=84c94cb4&scoped=true&"
import script from "./PartografTimeHeader.vue?vue&type=script&lang=ts&"
export * from "./PartografTimeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PartografTimeHeader.vue?vue&type=style&index=0&id=84c94cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c94cb4",
  null
  
)

export default component.exports